import { render, staticRenderFns } from "./aventraRedhat.vue?vue&type=template&id=401eb0fe&"
import script from "./aventraRedhat.vue?vue&type=script&lang=js&"
export * from "./aventraRedhat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports